import { Box, Button, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface JobsPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function JobsPagination({
  page,
  totalPages,
  onPageChange,
}: JobsPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        mt: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Button
        size="small"
        startIcon={<ChevronLeftIcon />}
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        Anterior
      </Button>
      <Typography variant="body2" color="text.secondary">
        Página {page} de {totalPages}
      </Typography>
      <Button
        size="small"
        endIcon={<ChevronRightIcon />}
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
      >
        Siguiente
      </Button>
    </Box>
  );
}
